import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const AnimationArrow = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 16 6"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      d="M0 3L5 5.88675L5 0.113248L0 3ZM4.5 3.5L16 3.5L16 2.5L4.5 2.5L4.5 3.5Z"
      fill="currentColor"
    />
  </SvgIcon>
);
